import { render, staticRenderFns } from "./Legs.vue?vue&type=template&id=c9615cfc&scoped=true&"
import script from "./Legs.vue?vue&type=script&lang=js&"
export * from "./Legs.vue?vue&type=script&lang=js&"
import style0 from "./Legs.vue?vue&type=style&index=0&id=c9615cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9615cfc",
  null
  
)

/* custom blocks */
import block0 from "./Legs.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports